import { JobOrderVersion as ServerJobOrderVersion } from 'server/models/JobOrderVersion';
import { PilotJobOrderVersionExtraData } from 'server/models/PilotJobOrderVersionExtraData';

export { JobOrderVersionData, JobOrderVersionOptions } from 'server/models/JobOrderVersion';

export class JobOrderVersion extends ServerJobOrderVersion {
    // aah: for now, since there are only PJO JOs, just type to only PJOV extra data
    ExtraData() : PilotJobOrderVersionExtraData | null {
        const json = this.ExtraDataJSON();
        return json && JSON.parse(json);
    }
}


// WEBPACK FOOTER //
// ./data/models/JobOrderVersion.ts